export const steps = [
  "Select payment mode",
  "Review and Receipt",
];

export const getHeaderItems = (studentData) => {
  return [
    {
      label: "BU",
      value: studentData?.bu,
    },
    {
      label: "Name",
      value: studentData?.studentName,
    },
    {
      label: "PSID",
      value: studentData?.psid,
    },
    // {
    //   label: "Application ID",
    //   value: studentData?.applicationId,
    // },

    {
      label: "Roll No.",
      value: studentData?.rollNumber,
    },
    {
      label: "Term",
      value: studentData?.term,
    },
    {
      label: "Exam ID",
      value: studentData?.examTimeCode,
    },
  ];
};  